export const PACKAGE_STATUSES = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  FAILURE: 'failure',
};

export const PACKAGE_LABELS = {
  PROD: 'PROD',
  BETA: 'BETA',
  DEV: 'DEV',
};

export const TEXT_FOR_PACKAGE_LABELS = {
  [PACKAGE_LABELS.PROD]: 'Stable Release',
  [PACKAGE_LABELS.BETA]: 'Beta',
  [PACKAGE_LABELS.DEV]: 'Dev',
};
